import React, { FC, SVGProps } from 'react';

const OpPlusDeliveryTruckIcon: FC<SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="31" cy="31" r="31" fill="#C6E2E6" />
      <path
        d="M52.0503 40.9714C52.0503 41.4472 51.6656 41.8342 51.1876 41.8342H48.0825C48.0916 41.907 48.0962 42.1164 48.0825 42.187C47.6933 44.1379 45.7401 45.0803 44.1807 45.0803C41.8383 45.0803 39.8874 43.3821 39.8874 41.8319C39.8783 41.9047 39.8874 41.759 39.8874 41.8319L35.2367 41.8137L30.1306 41.7955C30.1306 41.7226 30.1398 41.8683 30.1306 41.7955C30.1306 43.5551 28.1798 45.308 25.8373 45.308C24.0981 45.308 21.9358 43.5915 21.9358 41.8319C21.9267 41.9047 21.9358 41.759 21.9358 41.8319H19.2858C18.81 41.8319 18.423 40.9919 18.423 40.5138V18.8628C18.423 18.3847 18.8077 18 19.2858 18H40.3427C40.8185 18 41.1235 18.2299 41.1235 18.7057V25.4371C41.1235 25.9128 41.037 25.8263 41.5128 25.8263H48.5378C48.9043 25.8263 49.1911 27.1581 49.3118 27.5041L52.0025 35.2872C52.0344 35.3782 52.0503 35.4738 52.0503 35.5694V40.9691V40.9714Z"
        fill="#FFFDFD"
      />
      <path
        d="M26.2285 43.9538C27.8453 43.9538 29.156 42.6432 29.156 41.0264C29.156 39.4096 27.8453 38.0989 26.2285 38.0989C24.6117 38.0989 23.301 39.4096 23.301 41.0264C23.301 42.6432 24.6117 43.9538 26.2285 43.9538Z"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1807 43.9538C45.7975 43.9538 47.1081 42.6432 47.1081 41.0264C47.1081 39.4096 45.7975 38.0989 44.1807 38.0989C42.5639 38.0989 41.2532 39.4096 41.2532 41.0264C41.2532 42.6432 42.5639 43.9538 44.1807 43.9538Z"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7885 31.0736V19.366H40.0828V35.7585H19.7885V40.8304H23.3124"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4723 27.561H47.8889L50.6206 35.3669V40.8303H47.0967"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2641 40.8303H29.1444"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4974 33.8054H42.8148V29.9036H45.938L47.4974 33.8054Z"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0044 35.6423H13.3029"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5248 37.864H10.3414"
        stroke="#00909A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpPlusDeliveryTruckIcon;
